// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionButton_root__2_TwQ","bookLink":"ActionButton_bookLink__zp0PZ","detailsButton":"ActionButton_detailsButton__2XIEg"};